import { ReactNode } from 'react';
import { SectionDynamicContentfulModel } from 'src/api/models/SectionDynamic';
import DynamicComponents from './dynamicComponents';
import { TableCellContentfulModel } from 'src/api/models/ComparisonTable';

export default function getDynamicContentfulComponent(parentComponent: SectionDynamicContentfulModel | TableCellContentfulModel): ReactNode | ReactNode[] {
  if (Array.isArray(parentComponent.contentfulchildren)) {
    return parentComponent.contentfulchildren.map<ReactNode>((component) => {
      if (!component.internal) {
        return null;
      }

      const componentRenderer = DynamicComponents[ component.internal.type ];

      if (!componentRenderer) {
        return null;
      }

      return componentRenderer(component);
    })
  }
  const componentRenderer = DynamicComponents[ parentComponent.contentfulchildren.internal.type ];

  if (!componentRenderer) {
    return null;
  }

  return componentRenderer(parentComponent.contentfulchildren);
}
